import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSelector from '../LanguageSelector';
import AudienceSwitch from '../AudienceSwitch';

const PANEL_URL = 'https://panel.tenkusports.com';

const VenuesHeader = () => {
  const { t } = useTranslation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <header className="bg-gray-900 text-white py-4 px-6">
      <div className="max-w-7xl mx-auto flex justify-between items-center">
        <div className="flex items-center">
          <Link to="/" className="flex items-center space-x-3">
            <img src="/img/brand/isotipo-web.png" alt="" className="h-10" />
            <img src="/img/brand/logotipo-web.png" alt="Tenku" className="h-6" />
          </Link>
          <AudienceSwitch className="tk-audience--desktop" />
        </div>

        <nav className="hidden md:flex space-x-8 items-center">
          <a href="#features">{t('venues.header.features')}</a>
          <a href="#how-it-works">{t('venues.header.how')}</a>
          <a href="#pricing">{t('venues.header.pricing')}</a>
          <a href="#contact">{t('venues.header.contact')}</a>
          <a href={PANEL_URL} className="border border-gray-600 hover:border-brand hover:text-brand rounded-lg px-4 py-1.5 font-semibold transition-colors">
            {t('venues.header.login')}
          </a>
          <LanguageSelector />
        </nav>

        <div className="md:hidden flex items-center space-x-2">
          <LanguageSelector />
          <button
            onClick={toggleMenu}
            className="text-white hover:text-brand transition-colors p-2 -mr-2"
          >
            {isMenuOpen ? (
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            ) : (
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            )}
          </button>
        </div>
      </div>

      <div className="tk-audience-row">
        <AudienceSwitch />
      </div>

      {/* Mobile menu */}
      {isMenuOpen && (
        <div className="md:hidden mt-4 pb-4">
          <nav className="flex flex-col space-y-3">
            <a href="#features" onClick={closeMenu} className="text-gray-300 hover:text-brand transition-colors py-2">
              {t('venues.header.features')}
            </a>
            <a href="#how-it-works" onClick={closeMenu} className="text-gray-300 hover:text-brand transition-colors py-2">
              {t('venues.header.how')}
            </a>
            <a href="#pricing" onClick={closeMenu} className="text-gray-300 hover:text-brand transition-colors py-2">
              {t('venues.header.pricing')}
            </a>
            <a href="#contact" onClick={closeMenu} className="text-gray-300 hover:text-brand transition-colors py-2">
              {t('venues.header.contact')}
            </a>
            <a href={PANEL_URL} className="text-brand font-semibold py-2">
              {t('venues.header.login')}
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};

export default VenuesHeader;
